/**
 * NativeWaves Identity API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class RefreshApi extends runtime.BaseAPI {
    /**
     * Silent refresh to get a new access token for the user.
     */
    async refreshPostRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.tokenRequest,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Silent refresh to get a new access token for the user.
     */
    async refreshPost(requestParameters = {}, initOverrides) {
        const response = await this.refreshPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Revokes the user\'s refresh token.
     */
    async revokePostRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/revoke`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.tokenRequest,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Revokes the user\'s refresh token.
     */
    async revokePost(requestParameters = {}, initOverrides) {
        await this.revokePostRaw(requestParameters, initOverrides);
    }
}
//# sourceMappingURL=RefreshApi.js.map